import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Wrapper from "../../components/wrapper";
import {convertPipeToBrTag, formatDate} from "../../utils";
import './styles.css';
import Slider from "../../components/slider";
import {IS_MOBILE} from "../../constants/environment";
import Accordion from "../../components/accordion";

export default class Notification extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    function: PropTypes.string,
    title: PropTypes.string,
    mbTitle: PropTypes.string,
    hideImages: PropTypes.bool,
    notificationAreaItems: PropTypes.arrayOf(PropTypes.shape({
      smallImageSrc: PropTypes.string,
      publishedDate: PropTypes.string,
      pageName: PropTypes.string,
      pageTitle: PropTypes.string,
      mbPageTitle: PropTypes.string,
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
    })),
    notificationListTitle: PropTypes.string,
    notificationListItems: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      notificationItems: PropTypes.arrayOf(PropTypes.shape({
        smallImageSrc: PropTypes.string,
        publishedDate: PropTypes.string,
        pageName: PropTypes.string,
        pageTitle: PropTypes.string,
        mbPageTitle: PropTypes.string,
        href: PropTypes.string,
        targetBlank: PropTypes.bool,
      })),
    })),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    function: null,
    title: null,
    mbTitle: null,
    hideImages: null,
    notificationAreaItems: null,
    notificationListTitle: null,
    notificationListItems: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      linkHeight: 'auto'
    };
    this.timeoutId = null;
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleResize();
    }, 100)
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {

    // ------ Render ----- //

    // タイトル表示
    const renderTitle = ()=> {

      const getTitle = ()=> {
        if (this.props.title && this.props.title !== '') {
          return this.props.title;
        } else {
          return '';
        }
      };

      const getMbTitle = ()=> {
        if (this.props.mbTitle && this.props.mbTitle !== '') {
          return this.props.mbTitle;
        } else {
          return getTitle();
        }
      };

      const title = getTitle();
      const mbTitle = getMbTitle();

      if ((title && title !== '') || (mbTitle && mbTitle !== '')) {
        return (
          <h3 className="Notification__heading Wysiwyg">
            <span className="Notification__heading-pc" dangerouslySetInnerHTML={{__html: title}}/>
            <span className="Notification__heading-mb" dangerouslySetInnerHTML={{__html: mbTitle}}/>
          </h3>
        )
      } else {
        return null;
      }
    };

    // Notification Area
    const renderNotificationArea = ()=> {
      if (this.props.function !== 'Notification-Area') return null;

      const getText = (notificationAreaItem)=> {
        if (notificationAreaItem.pageTitle　&& notificationAreaItem.pageTitle !== '') {
          return notificationAreaItem.pageTitle;
        } else if (notificationAreaItem.pageName　&& notificationAreaItem.pageName !== '') {
          return notificationAreaItem.pageName;
        } else {
          return null;
        }
      };

      const getMbText = (notificationAreaItem)=> {
        if (notificationAreaItem.mbPageTitle && notificationAreaItem.mbPageTitle !== '') {
          return notificationAreaItem.mbPageTitle;
        } else {
          return getText(notificationAreaItem);
        }
      };

      const getNotificationAreaItems = ()=> {
        let items = [];
        let i, max;
        for (i = 0, max = this.props.notificationAreaItems.length; i < max; i = i + 1) {
          const item = this.props.notificationAreaItems[i];
          const date = formatDate(item.publishedDate, '.');
          if (date) {
            items.push(item);
          }
        }
        return items;
      };

      const renderItems = (notificationAreaItems)=> {
        if (notificationAreaItems && notificationAreaItems instanceof Array) {
          return (
            notificationAreaItems.map((notificationAreaItem, index)=> {
              const date = formatDate(notificationAreaItem.publishedDate, '.');
              if (!date) return null;
              //
              let src = null;
              if (!this.props.hideImages && notificationAreaItem.smallImageSrc && notificationAreaItem.smallImageSrc !== '') {
                src = notificationAreaItem.smallImageSrc;
              }
              const text = getText(notificationAreaItem);
              const mbText = getMbText(notificationAreaItem);
              // リンクかどうかの出し分け
              if (notificationAreaItem.href && notificationAreaItem.href !== '') {
                return (
                  <li key={index}>
                    <div className="Notification__area__container">
                      <a className={'Notification__area__link' + ((notificationAreaItem.targetBlank === true) ? ' blank' : '')}
                         href={(notificationAreaItem.href) ? notificationAreaItem.href : ''}
                         target={(notificationAreaItem.targetBlank === true) ? '_blank' : ''}
                         style={{height: this.state.linkHeight}}
                      >
                        <div className="Notification__area__link-content">
                          {(src) ? <div className="Notification__area__image-wrapper"><img className="Notification__area__image" src={src} onLoad={()=> {
                            if (this.timeoutId) clearTimeout(this.timeoutId);
                            this.timeoutId = setTimeout(()=> {
                              this.handleResize();
                            }, 200);
                          }}/></div> : null}
                          {(text) ? <p className="Notification__area__text-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/> : null}
                          {(mbText) ? <p className="Notification__area__text-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                          {(date) ? <p className="Notification__area__date">{date}</p> : null}
                        </div>
                      </a>
                    </div>
                  </li>
                )
              } else {
                return (
                  <li key={index}>
                    <div className="Notification__area__container">
                      <div className="Notification__area__link disabled" style={{height: this.state.linkHeight}}>
                        <div className="Notification__area__link-content">
                          {(src) ? <div className="Notification__area__image-wrapper"><img className="Notification__area__image" src={src} onLoad={()=> {
                            if (this.timeoutId) clearTimeout(this.timeoutId);
                            this.timeoutId = setTimeout(()=> {
                              this.handleResize();
                            }, 200);
                          }}/></div> : null}
                          {(text) ? <p className="Notification__area__text-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/> : null}
                          {(mbText) ? <p className="Notification__area__text-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                          {(date) ? <p className="Notification__area__date">{date}</p> : null}
                        </div>
                      </div>
                    </div>
                  </li>
                )
              }
            })
          )
        } else {
          return null;
        }
      };

      const notificationAreaItems = getNotificationAreaItems();

      return (
        <div className="Notification__area">
          {(() => {
            if (!this.state.isMounted) return null;

            var IS_BROWSER2 = typeof window !== 'undefined';
            var WINDOW2 = IS_BROWSER2 && window;
            var NAVIGATOR2 = WINDOW2 && WINDOW2.navigator;
            var IS_IOS2 = NAVIGATOR2 && /iPhone|iPad|iPod/i.test(NAVIGATOR2.userAgent || '');
            var IS_ANDROID2 = NAVIGATOR2 && /Android/i.test(NAVIGATOR2.userAgent || '');
            var IS_MOBILE2 = NAVIGATOR2 && /iPhone|iPod|Android/i.test(NAVIGATOR2.userAgent);
            // console.log('IS_BROWSER: ', IS_BROWSER2);
            // console.log('WINDOW: ', WINDOW2);
            // console.log('NAVIGATOR: ', NAVIGATOR2);
            // console.log('IS_IOS: ', IS_IOS2);
            // console.log('IS_ANDROID: ', IS_ANDROID2);
            // console.log('IS_MOBILE2: ', IS_MOBILE2);
            // console.log('IS_MOBILE: ', IS_MOBILE);

            if (notificationAreaItems && notificationAreaItems.length <= ((IS_MOBILE === true) ? 2 : 4)) {
              return (
                <ul className="Notification__area__items fixed" ref="items">
                  {renderItems(notificationAreaItems)}
                </ul>
              )
            } else if (notificationAreaItems && ((IS_MOBILE === true) ? 3 : 5) <= notificationAreaItems.length) {
              return (
                <ul className="Notification__area__items" ref="items">
                  <Slider settings={{
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                    fade: false,
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    swipe: true,
                    draggable: false,
                    arrows: true,
                    dots: true,
                    adaptiveHeight: false,
                    centerMode: false,
                    centerPadding: 0,
                    waitForAnimate: false,
                    lazyLoad: 'progressive',
                    responsive: [
                      {
                        breakpoint: 767,
                        settings: {
                          speed: 500,
                          slidesToShow: 2,
                          slidesToScroll: 2,
                          arrows: false,
                        },
                      },
                    ],
                  }}>
                    {renderItems(notificationAreaItems)}
                  </Slider>
                </ul>
              )
            } else {
              return null;
            }
          })()}
        </div>
      )

    };

    // Notification List
    const renderNotificationList = ()=> {
      if (this.props.function !== 'Notification-List') return null;

      const getText = (notificationItem)=> {
        if (notificationItem.pageTitle && notificationItem.pageTitle !== '') {
          return notificationItem.pageTitle;
        } else if (notificationItem.pageName && notificationItem.pageName !== '') {
          return notificationItem.pageName;
        } else {
          return null;
        }
      };

      const getMbText = (notificationListItem)=> {
        if (notificationListItem.mbPageTitle && notificationListItem.mbPageTitle !== '') {
          return notificationListItem.mbPageTitle;
        } else {
          return getText(notificationListItem);
        }
      };

      const renderItem = (notificationItem)=> {
        const date = formatDate(notificationItem.publishedDate, '.');
        if (!date) return null;
        //
        let src = null;
        if (!this.props.hideImages && notificationItem.smallImageSrc && notificationItem.smallImageSrc !== '') {
          src = notificationItem.smallImageSrc;
        }
        const text = getText(notificationItem);
        const mbText = getMbText(notificationItem);
        // リンクかどうかの出し分け
        if (notificationItem.href && notificationItem.href !== '') {
          return (
            <a className={'Notification__list__link' + ((notificationItem.targetBlank === true) ? ' blank' : '') + ((this.props.hideImages === true || src === null) ? ' hideImage' : '')}
               href={(notificationItem.href) ? notificationItem.href : ''}
               target={(notificationItem.targetBlank === true) ? '_blank' : ''}
            >
              <div className="Notification__list__box3">
                <div className="Notification__list__box3-left">
                  {(src) ? <img className="Notification__list__image" src={src}/> : null}
                </div>
                <div className="Notification__list__box3-right">
                  {(date) ? <p className="Notification__list__date">{date}</p> : null}
                  {(text) ? <p className="Notification__list__text-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/> : null}
                  {(mbText) ? <p className="Notification__list__text-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                </div>
              </div>
            </a>
          )
        } else {
          return (
            <div className={'Notification__list__link disabled' + ((this.props.hideImages === true || src === null) ? ' hideImage' : '')}>
              <div className="Notification__list__box3">
                <div className="Notification__list__box3-left">
                  {(src) ? <img className="Notification__list__image" src={src}/> : null}
                </div>
                <div className="Notification__list__box3-right">
                  {(date) ? <p className="Notification__list__date">{date}</p> : null}
                  {(text) ? <p className="Notification__list__text-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/> : null}
                  {(mbText) ? <p className="Notification__list__text-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                </div>
              </div>
            </div>
          )
        }
      };

      if (this.props.notificationListItems && this.props.notificationListItems instanceof Array) {
        return (
          <div className="Notification__list">
            {(this.props.notificationListTitle && this.props.notificationListTitle !== '') ?
              <h4 className="Notification__list__heading">{this.props.notificationListTitle}</h4>
              : null}
            {this.props.notificationListItems.map((notificationListItem, index) => {
              const isOpen = (index <= 0) ? true : false;
              return (
                <div className="Notification__list__box" key={index}>
                  <Accordion
                    pageName={notificationListItem.pageName}
                    pcText={notificationListItem.pageName}
                    mbText={notificationListItem.pageName}
                    open={isOpen}
                  >
                    {notificationListItem.notificationItems.map((notificationItem, index2) => {
                      return (
                        <div className="Notification__list__box2" key={index2}>
                          {renderItem(notificationItem)}
                        </div>
                      )
                    })}
                  </Accordion>
                </div>
              )
            })}
          </div>
        )
      } else {
        return null;
      }
    };

    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="Notification">

          {renderTitle()}

          {renderNotificationArea()}

          {renderNotificationList()}

        </div>
      </Wrapper>
    )
  }

  //
  handleResize = () => {
    let maxHeight  = 0;
    const items = (this.refs.items) ? this.refs.items.getElementsByClassName('Notification__area__link-content') || null : null;
    if (items && 1 <= items.length) {
      let i, max;
      for (i = 0, max = items.length; i < max; i = i + 1) {
        const height = items[i].clientHeight;
        if (maxHeight < height) {
          maxHeight = height;
        }
      }
    }
    this.setState({
      linkHeight: maxHeight
    })
  };

}



// WEBPACK FOOTER //
// ./src/containers/notification/index.jsx